<template>
  <div class="subtitleFrame">
    <div class="subtitleContainer"  v-show="withSubtitles==true">
      <div id="subtitlesTag"></div>
    </div>
  </div>
</template>

<style>
.subtitleFrame {
  border-radius: 10px;
  height: 50px;
  background-color: transparent;
  justify-content: center;
  display: flex;
}


.shaka-text-container:not(:empty){
  padding: 20px;
}

.shaka-text-container:empty{
  padding: 0px;
  visibility: hidden;
}

.subtitleContainer:not(:empty) {
  bottom: 150px;
  line-height: 130%;
  position: absolute;
  justify-content: center;
  font-size: 22px;
  color: white;
  background-color: black;
  opacity: 0.7;
  display: flex;
  border-radius: 21px;
  /*background: linear-gradient(to top, transparent, rgba(0, 0, 0, 0.95) 4rem);*/
}

.title-card {
  width: 40%;
  min-width: 220px;
  padding: 3rem;
  padding-bottom: 6rem;

  background: linear-gradient(
    to top,
    transparent,
    rgba(255, 255, 255, 0.85) 4rem
  );
  border-radius: 10px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;

  display: flex;
  flex-direction: column;
  gap: 24px;
}
</style>
<script>
import { BlackAndWhitePostProcess } from "babylonjs";
import { mapGetters, mapMutations } from "vuex";

export default {
  data: function () {
    return {
      text: "Subtiltes....",
    };
  },
  computed: {
    ...mapGetters(["withSubtitles"]),
  },
};
</script>
